/**
 * Benvel PDP gallery slide counter ("01 / 06").
 *
 * Design source: docs/design/Benvel Product Page (1)/pdp/mobile.jsx — the
 * mobile gallery shows a zero-padded "current / total" chip bottom-right.
 *
 * Horizon's native `counter` slideshow control renders an un-padded "1/6" pill
 * and would replace the dots. Instead this is an additive, mobile-only overlay
 * that keeps the dots and listens to Horizon's bubbling `slideshow:select`
 * event (assets/events.js → SlideshowSelectEvent, detail.index) to update a
 * zero-padded current number. Zero, no-JS-fallback markup ships the initial
 * "01" so the chip is correct before the first interaction.
 */
class BenvelGalleryCounter extends HTMLElement {
  connectedCallback() {
    this.currentEl = this.querySelector('[data-current]');
    this.slideshow = this.closest('slideshow-component');
    this.onSelect = this.onSelect.bind(this);
    (this.slideshow || this).addEventListener('slideshow:select', this.onSelect);
  }

  disconnectedCallback() {
    (this.slideshow || this).removeEventListener('slideshow:select', this.onSelect);
  }

  onSelect(event) {
    const index = event?.detail?.index;
    if (typeof index !== 'number' || !this.currentEl) return;
    this.currentEl.textContent = String(index + 1).padStart(2, '0');
  }
}

if (!customElements.get('benvel-gallery-counter')) {
  customElements.define('benvel-gallery-counter', BenvelGalleryCounter);
}
